import React from "react";
import { Box } from "@mui/material";
import { BigHeadline } from "../../../../components/TextParts";
import RecruitmentSearchFromCondition from "../organisms/RecruitmentSearchFromCondition";

export default function RecruitmentListTemplate() {
  return (
    <Box>
      <BigHeadline text="募集一覧" />
      <RecruitmentSearchFromCondition />
    </Box>
  );
}